


  export default  class  UserRole {  public static readonly SalesPerson = new UserRole('SalesPerson','SalesPerson',0) ;
  public static readonly Manager = new UserRole('Manager','Manager',1) ;
  public static readonly Admin = new UserRole('Admin','Admin',2) ;
  private _ident: string ;
  private _name: string ;
  private _index: number ;
 public constructor ( _ident : string,_name : string,_index : number ) {
 this._ident=_ident;

this._name=_name;

this._index=_index;
 }
  public static get values (  ) : UserRole[] {
 return [ UserRole.SalesPerson, UserRole.Manager, UserRole.Admin ] ; 
 }
  public get ident (  ) : string {
 return this._ident ; 
 }
  public get name (  ) : string {
 return this._name ; 
 }
  public get index (  ) : number {
 return this._index ; 
 }
  public toString (  ) : string {
 return this._name ; 
 }
 }